import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ContainerForm } from '@/components/Form/ContainerForm'
import { postcentreConfiguration, updatecentreConfiguration } from '@/store/centreConfigurations/actions'
import { updateCentreAdmin } from '@/store/centres/actions'
import { createMercadoPagoSubscription } from '@/store/mercadoPago/actions'
import { postNewSubscriptionPayment } from '@/store/subscriptionPayments/actions'
import { showToast } from '@/utils/toast'
import { yupResolver } from '@hookform/resolvers/yup'

import dayjs from 'dayjs'
import { formDefaultValues } from './formConfig'
import { FormContent } from './formContent'
import { formValidationSchema } from './formValidation'

const FormInfoSubscription = ({ formValues }) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [suggestedPrice, setSuggestedPrice] = useState('')
  const [finalPrice, setFinalPrice] = useState('')
  const { allSubscriptionPlans } = useSelector((state) => state?.subscriptionPlans)

  const handleSubmit = async (data, event) => {
    setIsLoading(true)

    const buttonId = event?.nativeEvent?.submitter?.id
    const hideAlert = buttonId === 'createMPSubscription'
    const selectedPlan = allSubscriptionPlans?.find((plan) => plan.id === data.centreConfiguration.subscriptionPlan)
    const period = dayjs().utc(true).startOf('month').format()
    const dueDate = dayjs(period).utc(true).add(10, 'day').startOf('day').format()

    let auxSubscriptionData = {
      ...data,
      auxAmount: finalPrice,
      centreConfiguration: {
        ...data.centreConfiguration,
        subscriptionPlan: selectedPlan,
        subscriptionAgendasQuantity: data.centreConfiguration.subscriptionAgendasQuantity,
        amount: finalPrice,
        period: period,
        dueDate: dueDate,
      },
    }

    let auxCentreConfiguration

    if (!formValues?.centreConfiguration) {
      const centreConfigData = {
        centre: data?._id,
        ...auxSubscriptionData.centreConfiguration,
      }
      const centreConfig = await dispatch(postcentreConfiguration(centreConfigData, true))
      auxCentreConfiguration = centreConfig
    } else {
      auxCentreConfiguration = auxSubscriptionData.centreConfiguration
      await dispatch(updatecentreConfiguration(auxCentreConfiguration))
    }

    auxSubscriptionData.centreConfiguration = auxCentreConfiguration

    try {
      const parsedData = JSON.parse(JSON.stringify(auxSubscriptionData))
      await dispatch(updateCentreAdmin(parsedData, hideAlert))
      if (buttonId === 'createMPSubscription') {
        await dispatch(createMercadoPagoSubscription(auxSubscriptionData))
        await dispatch(postNewSubscriptionPayment(auxSubscriptionData.centreConfiguration, true))
        showToast('Suscripción Mercado Pago creada correctamente', 'success')
      }
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      showToast('Error al actualizar la configuración del centro', 'error')
      setIsLoading(false)
    }
  }

  return (
    <div>
      <ContainerForm
        onSubmit={(data, event) => handleSubmit(data, event)}
        defaultValues={{ ...formDefaultValues, ...formValues }}
        resolver={yupResolver(formValidationSchema)}
      >
        <FormContent
          isLoading={isLoading}
          suggestedPrice={suggestedPrice}
          setSuggestedPrice={setSuggestedPrice}
          finalPrice={finalPrice}
          setFinalPrice={setFinalPrice}
        />
      </ContainerForm>
    </div>
  )
}

export default FormInfoSubscription
